// ============================================
// GWP Badges — Haarspullen.nl
// Eén keer laden (asset), in plaats van inline script in elke gwp-badge render.
// ============================================
(function () {
  if (window.__gwpBadgesInit) return;
  window.__gwpBadgesInit = true;

  // Cache de PROMISE (niet het resultaat), zodat meerdere badges met dezelfde
  // gift-handle maar één request veroorzaken.
  var productPromises = {};
  function gwpFetchProduct(handle) {
    if (!productPromises[handle]) {
      productPromises[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }
    return productPromises[handle];
  }

  function processBadge(badge, displayValue) {
    badge.setAttribute('data-gwp-checked', 'true');
    var handle = badge.getAttribute('data-gwp-handle');
    var variantId = badge.getAttribute('data-gwp-variant');
    if (!handle) return;
    gwpFetchProduct(handle).then(function (p) {
      if (!p) return;
      var available = p.variants.some(function (v) {
        return String(v.id) === String(variantId) && v.available;
      });
      if (available) badge.style.display = displayValue;
    });
  }

  function gwpCheckBadges() {
    var badges = document.querySelectorAll('.gwp-badge:not([data-gwp-checked])');
    for (var i = 0; i < badges.length; i++) processBadge(badges[i], '');
    var mobile = document.querySelectorAll('.gwp-badge--mobile:not([data-gwp-checked])');
    for (var j = 0; j < mobile.length; j++) processBadge(mobile[j], 'block');
  }

  // Debounce + wachten tot de browser idle is, zodat dit nooit tijdens een klik draait
  var scheduled = false;
  function scheduleCheck() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; gwpCheckBadges(); };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 1000 });
    else setTimeout(run, 200);
  }

  document.addEventListener('DOMContentLoaded', scheduleCheck);
  document.addEventListener('collection:updated', scheduleCheck);
  document.addEventListener('page:loaded', scheduleCheck);

  // Eén observer, alleen nodig als er na laden producten bijkomen (filters, sliders, quickshop).
  // Goedkope check per toegevoegd node; het eigenlijke werk wordt gedebounced.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (
          (n.classList && (n.classList.contains('gwp-badge') || n.classList.contains('gwp-badge--mobile'))) ||
          (n.querySelector && n.querySelector('.gwp-badge, .gwp-badge--mobile'))
        ) {
          scheduleCheck();
          return;
        }
      }
    }
  });

  function startObserver() {
    // Observeer alleen de content, niet het hele document
    var target = document.getElementById('content') || document.body;
    observer.observe(target, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver);
  else startObserver();
})();